import { createContext, useState } from "react";

export const AdminContext = createContext({
  showLogoutModal: false,
  handleLogoutClick: () => {},
  handleCloseModal: () => {},
  isSidebarOpen: true,
  handleSidebarToggle: () => {},
  handleSidebarClose: () => {},
});
const AdminProvider = ({ children }) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isSidebarOpen, setSidebarOpen] = useState(true);

  const handleLogoutClick = (e) => {
    if (e) e.preventDefault();
    setShowLogoutModal(true);
  };
  const handleCloseModal = () => setShowLogoutModal(false);
  const handleSidebarToggle = () => setSidebarOpen(!isSidebarOpen);
  const handleSidebarClose = () => setSidebarOpen(false);
  return (
    <AdminContext.Provider
      value={{
        showLogoutModal,
        handleLogoutClick,
        handleCloseModal,
        isSidebarOpen,
        handleSidebarToggle,
        handleSidebarClose,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};
export default AdminProvider;
